import { httpClient } from './http-clients/http-client';

interface Setting {
    value: string;
}

export const getSettingValue = async (key: string) => {
    try {
        const response = await httpClient.get<Setting>(`/api/setting?key=${key}`);
        return response?.data?.value;
    } catch {
        return null;
    }
};
